import { createSelector } from '@ngrx/store';
import { RetryConfig, timer } from 'rxjs';

/* istanbul ignore next */
export const verifyUserIsProvisionedRetryConfig = {
  count: 5,
  delay: (error, retryCount) => timer(retryCount * 2000),
} as RetryConfig;

export const selectVerifyUserIsProvisionedRetryConfig = createSelector(() => {
  return verifyUserIsProvisionedRetryConfig;
});
